import { render, staticRenderFns } from "./PublicTender.vue?vue&type=template&id=17bffa07&scoped=true&"
import script from "./PublicTender.vue?vue&type=script&lang=js&"
export * from "./PublicTender.vue?vue&type=script&lang=js&"
import style0 from "./PublicTender.vue?vue&type=style&index=0&id=17bffa07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bffa07",
  null
  
)

export default component.exports